var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5dec0358e42a6bd06ff89c9f4b4bea60803c2a22"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-app@groove"]={id:"5dec0358e42a6bd06ff89c9f4b4bea60803c2a22"};
      